<script lang="ts" setup>
import type { HTMLAttributes } from "vue"
import { useClass } from "~/composables/local/cn-class"
import { useFormField } from "./useFormField"

const props = defineProps<{
	class?: HTMLAttributes["class"]
}>()

const { formDescriptionId } = useFormField()

const className = useClass(
	"text-sm text-muted-foreground",
	() => props.class,
)
</script>

<template>
	<p
		:id="formDescriptionId"
		:class="className">
		<slot />
	</p>
</template>
